//External
import React from "react";
import Link from "next/link";
//Internal
import errorImg from "../../public/assets/images/error-img.svg";

/*******************
  @Purpose : used for 404
  @Parameter : {currentLocationId,locations,userInfo,}
  @Author : INIC
  *******************/
const Fournotfour = () => {
  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <div className="error-page py-60">
      <div className="custom-container">
        <div className="content-404 text-center">
          <div className="error-img">
            <img src={errorImg} width={"100%"} alt="404 Error img" />
          </div>
          <h2 className="mt-4 mt-sm-5 content-404-title ff-hel-reg">
            Oops 404 <br />
            This is somewhat embarrassing, isn’t it?
          </h2>
          <div className="content-404-link mt-4">
            <Link href="/">
              <a className="btn btn-primary mt-50" title="Back To Home">
                <span className="icon-left-caret"></span>Go to Home page
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fournotfour;
